import { render, staticRenderFns } from "./LayerEditor.vue?vue&type=template&id=05d79a3c&"
import script from "./LayerEditor.vue?vue&type=script&lang=ts&"
export * from "./LayerEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports